import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { goToPrevStep } from '~/src/features/full-buy/store/actions/goToPrevStep';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TAppThunkDispatch, TGetState } from '~/src/store';

/**
 * Пропускаем шаг выбора роутера, если есть в тарифе
 */
const skipEquipmentStep = () => (dispatch: TAppThunkDispatch, getState: TGetState) => {
    const state = getState();
    const selectedTariff = selectCurrentTariff(state);
    const { stepIndex, prevStepIndex } = state.fullBuy;

    const isBackward = prevStepIndex > stepIndex;

    const hasEquipmentInTariff = selectedTariff?.additionalProducts.some(product => product.category === 'router' && product.required);

    if (hasEquipmentInTariff) {
        dispatch(isBackward ? goToPrevStep() : goToNextStep());
    }
};

export default skipEquipmentStep;
